import { render } from "./AccountDeletion.vue?vue&type=template&id=7310e2b2&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&lang=js"

import "./AccountDeletion.vue?vue&type=style&index=0&id=7310e2b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7310e2b2"]])

export default __exports__